import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Col, Container, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import { Link, useParams, useNavigate } from "react-router-dom";
import classnames from "classnames";

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import BookingsTable from './bookingsTable';
import VehiclesTable from './vehiclesTable';
import VehiclesDocumentsTable from './vehiclesDocumentsTable';
import DriverDocuments from "./driverDocumentsTable";

import ProfileChart from "./profile-chart";

// Import Images
import avatar3 from "../../assets/images/users/avatar-3.jpg";

import { fetchDriversDetailsData, fetchDriversDetailsFailure } from "../../store/drivers/actions";

const DriversProfile = props => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { data, loading, error } = useSelector(
        (state) => state.Drivers.details || {}
    );

    useEffect(() => {
        if (id) {
            dispatch(fetchDriversDetailsData(id));
        }
    }, [dispatch, id]);

    const [customActiveTab, setcustomActiveTab] = useState("1");
    const toggleCustom = (tab) => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab);
        }
    };

    document.title = "Driver Details | Moeen";
    return (
        <React.Fragment>
            <div className="page-content pt-2">
                <Container fluid>

                    <Breadcrumbs maintitle="Home" title="Drivers" breadcrumbItem="Driver Details" />

                    <Row>
                        <Col xl={3}>
                            <div className="user-sidebar">
                                <Card>
                                    <CardBody>
                                        <div className="mt-n4 position-relative">
                                            <div className="text-center">
                                                {loading ? (
                                                    <Skeleton circle height={80} width={80} />
                                                ) : (
                                                    <img src={data?.data?.profile_pic ?? avatar3} alt="" className="avatar-xl rounded-circle img-thumbnail" />
                                                )}

                                                <div className="mt-3">
                                                    <h5 className="">
                                                        {loading ? <Skeleton width={100} /> : data?.data?.name}
                                                    </h5>
                                                    <div>
                                                        {loading ? <Skeleton width={120} /> : <span className="text-muted m-1">{data?.data?.phone_code + ' ' + data?.data?.mobno}</span>}
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div className="p-3 mt-3">
                                            <Row className="text-center">
                                                <Col className="border-end">
                                                    <div className="p-1">
                                                        <h5 className="mb-1">{loading ? <Skeleton width={10} /> : data?.data?.total_bookings}</h5>
                                                        <p className="text-muted mb-0">Bookings</p>
                                                    </div>
                                                </Col>
                                                <Col>
                                                    <div className="p-1">
                                                        <h5 className="mb-1">{loading ? <Skeleton width={10} /> : 0}</h5>
                                                        <p className="text-muted mb-0">Rating</p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </CardBody>
                                </Card>


                                <Card className="shadow-sm border-0 rounded-3">
                                    <div className="card-header bg-light">
                                        <h4 className="card-title mb-0">Personal Information</h4>
                                    </div>

                                    <CardBody>
                                        {loading ? (
                                        <ul className="list-unstyled mb-0">
                                            {[...Array(5)].map((_, index) => (
                                            <li
                                                key={index}
                                                className="d-flex justify-content-between p-2 font-size-15 border-bottom"
                                            >
                                                <Skeleton width={200} />
                                            </li>
                                            ))}
                                        </ul>
                                        ) : (
                                        <ul className="list-unstyled mb-0">
                                            <li className="d-flex justify-content-between align-items-start p-3 border-bottom">
                                            <span className="text-muted fw-semibold">Full Name</span>
                                            <span className="fw-bold text-dark text-end ms-3 flex-grow-1">
                                                {data?.data?.user_name}
                                            </span>
                                            </li>

                                            <li className="d-flex justify-content-between align-items-start p-3 border-bottom">
                                            <span className="text-muted fw-semibold">Email</span>
                                            <span
                                                className="fw-bold text-dark text-end ms-3 flex-grow-1"
                                                style={{ wordBreak: "break-word" }}
                                            >
                                                {data?.data?.email}
                                            </span>
                                            </li>

                                            <li className="d-flex justify-content-between align-items-start p-3 border-bottom">
                                            <span className="text-muted fw-semibold">Phone Code</span>
                                            <span className="fw-bold text-dark text-end ms-3 flex-grow-1">
                                                {data?.data?.phone_code}
                                            </span>
                                            </li>

                                            <li className="d-flex justify-content-between align-items-start p-3 border-bottom">
                                            <span className="text-muted fw-semibold">Mobile Number</span>
                                            <span className="fw-bold text-dark text-end ms-3 flex-grow-1">
                                                {data?.data?.mobno}
                                            </span>
                                            </li>

                                            <li className="d-flex justify-content-between align-items-start p-3">
                                            <span className="text-muted fw-semibold">Status</span>
                                            <span className="fw-bold text-success text-end ms-3 flex-grow-1">
                                                {data?.data?.status}
                                            </span>
                                            </li>
                                        </ul>
                                        )}
                                    </CardBody>
                                    </Card>

                                <Card>
                                    <CardBody>
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0 me-3">
                                                <div className="avatar-xs">
                                                    <div className="avatar-title rounded-circle bg-primary bg-gradient fs-4">
                                                        <i className="mdi mdi-chart-pie"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex-grow-1">
                                                <p className="text-muted mb-1">Revenue</p>
                                                <h5 className="mb-0">{loading ? <Skeleton width={100} /> : ('LYD ' + data?.data?.total_revenue ?? 'LYD' + 0.00)}</h5>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>



                                <Card>
                                    <CardBody>
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0 me-3">
                                                <div className="avatar-xs">
                                                    <div className="avatar-title rounded-circle bg-primary bg-gradient fs-4">
                                                        <i className="mdi mdi-wallet"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex-grow-1">
                                                <p className="text-muted mb-1">Wallet</p>
                                                <h5 className="mb-0">{loading ? <Skeleton width={100} /> : ('LYD ' + data?.data?.wallet_amount ?? 'LYD' + 0.00)}</h5>
                                            </div>
                                        </div>
                                    </CardBody>

                                </Card>
                                <Card>
                                    <CardBody>
                                        <div className="d-flex align-items-center">
                                            <div className="flex-shrink-0 me-3">
                                                <div className="avatar-xs">
                                                    <div className="avatar-title rounded-circle bg-primary bg-gradient fs-4">
                                                        <i className="mdi mdi-dump-truck"></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex-grow-1">
                                                <p className="text-muted mb-1">Vehicles</p>
                                                <h5 className="mb-0">{loading ? <Skeleton width={100} /> : (data?.data?.vehicles?.length ?? 0)}</h5>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            </div>
                        </Col>

                        <Col xl={9}>
                            <Card>
                                <CardBody>
                                    <div id="profile-chart" className="apex-charts">
                                        {loading ? (
                                            <Skeleton height={300} />
                                        ) : (
                                            <ProfileChart value={data?.data?.bookings_yearly || []} />
                                        )}
                                    </div>
                                </CardBody>
                            </Card>

                            <Card>
                                <Nav tabs className="nav nav-tabs nav-tabs-custom nav-justified">
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "1",
                                            })}
                                            onClick={() => {
                                                toggleCustom("1");
                                            }}
                                        >
                                            <i className="bx bx-user-circle font-size-20"></i>
                                            <span className="d-none d-sm-block">Bookings</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "2",
                                            })}
                                            onClick={() => {
                                                toggleCustom("2");
                                            }}
                                        >
                                            <i className="bx bx-clipboard font-size-20"></i>
                                            <span className="d-none d-sm-block">Vehicles</span>
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink
                                            style={{ cursor: "pointer" }}
                                            className={classnames({
                                                active: customActiveTab === "3",
                                            })}
                                            onClick={() => {
                                                toggleCustom("3");
                                            }}
                                        >
                                            <i className="bx bx-mail-send font-size-20"></i>
                                            <span className="d-none d-sm-block">Vehicles Documents</span>
                                        </NavLink>
                                    </NavItem>
                                </Nav>

                                <TabContent
                                    activeTab={customActiveTab}
                                    className="p-4"
                                >
                                    <TabPane tabId="1">

                                        <div>
                                            <div>
                                                <h5 className="font-size-16 mb-4">Bookings</h5>

                                                <BookingsTable bookings={data?.data?.bookings} />
                                            </div>
                                        </div>

                                    </TabPane>
                                    <TabPane tabId="2">

                                        <div>
                                            <div>
                                                <h5 className="font-size-16 mb-4">Vehicles</h5>

                                                <VehiclesTable vehicles={data?.data?.vehicles} />
                                            </div>
                                        </div>

                                    </TabPane>
                                    <TabPane tabId="3">

                                        <div>
                                            <div>
                                                <h5 className="font-size-16 mb-4">Vehicles Documents</h5>

                                                <VehiclesDocumentsTable vehicles={data?.data?.vehicles} />
                                            </div>
                                        </div>

                                    </TabPane>
                                </TabContent>
                            </Card>

                            <Card>
                                <div className="p-4 pb-0">
                                    <h5 className="card-title mb-0">Driver Documents</h5>
                                </div>

                                <DriverDocuments />
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default DriversProfile;
